// extracted by mini-css-extract-plugin
module.exports = {"container":"v_alert_container_container__ivEYq","icon":"v_alert_container_icon__29b1W","text":"v_alert_container_text__3vaIw","error_text":"v_alert_container_error_text__1eHnL"};